module.exports = __webpack_public_path__ + "img/gj.27fac420.jpg";